import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TTekiseiSindanGetRes,
  TTekiseiSindanListGetReq,
  TTekiseiSindanListGetRes,
  TTekiseiSindanPostReq,
  TTekiseiSindanPutReq,
  TTekiseiSindanZissiListGetReq,
  TTekiseiSindanZissiListGetRes,
} from "./TTekiseiSindan"

/**
 * 適性診断に対するAPIリクエスト用サービス
 *
 * @export
 * @class
 * @extends {ConnectApi}
 */
export default class TekiseiSindanService extends ConnectApi {
  /**
   * 適性診断リスト
   * @param params
   * @returns
   */
  getList = async (params: TTekiseiSindanListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTekiseiSindanListGetRes[]>> =
        await this.getInner(`/driver/tekiseisindanlist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 適性診断実施一覧取得
   * @param {TTekiseiSindanZissiListGetReq} data
   * @returns
   */
  getZissiList = async (data: TTekiseiSindanZissiListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTekiseiSindanZissiListGetRes[]>> =
        await this.getInner(`/driver/tekiseisindanzissilist`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 適性診断取得
   * @param id:適性診断ID
   * @returns
   */
  get = async (id: number) => {
    try {
      const res: AxiosResponse<TApiResponse<TTekiseiSindanGetRes>> =
        await this.getInner(`/driver/tekiseisindanlist/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点検診断更新
   * @param id
   * @param data
   * @returns
   */
  put = async (id: number, data: TTekiseiSindanPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driver/tekiseisindanlist/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点検診断登録
   * @param data
   * @returns
   */
  post = async (data: TTekiseiSindanPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `driver/tekiseisindanlist`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 適性診断削除
   * @param id
   * @returns
   */
  delete = async (id: number, modifiedDate: string) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.deleteInner(
        `/driver/tekiseisindanlist/${id}`,
        { 更新日時: modifiedDate }
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
